export const iconFontAwesomeToggleStarHalfStroke = (
	<i className="fa-solid fa-star-half-stroke"></i>
);
